export default {
  name: "dark",
  brand: {
    primary: "#35C79B",
    secondary: "#29DEAE",
    hover: "#4FD9B2",
    progress: "#29DEAE",
    contrast: "#0E1421",
    soft: "rgba(41, 222, 174, 0.14)",
    primarySoft: "rgba(53, 199, 155, 0.45)",
    logoFilter: "brightness(0) invert(1)",
    gradient: "linear-gradient(40deg, #29DEAE -20.66%, #1F8C6E 68.48%)",
    gradientReverse: "linear-gradient(40deg, #1F8C6E -20%, #29DEAE 70%)",
    gradientBar: "linear-gradient(100deg, #1F8C6E -20.66%, #29DEAE 68.48%)",
  },
  body: {
    background: "#0E1421",
    color: "#98A1B5",
  },
  text: {
    primary: "#E6EAF4",
    secondary: "#98A1B5",
    muted: "#8A93A6",
    inverse: "#fff",
  },
  surface: {
    background: "#161D2C",
    muted: "#1E2637",
    hover: "#232C40",
    border: "#2B3446",
    divider: "#2B3446",
    shadow: "rgba(0, 0, 0, 0.55)",
    selected: "rgba(53, 199, 155, 0.12)",
    borderSoft: "rgba(255, 255, 255, 0.08)",
    subtle: "rgba(255, 255, 255, 0.06)",
    faint: "rgba(255, 255, 255, 0.03)",
    loadingOverlay: "rgba(14, 20, 33, 0.8)",
    spinnerOverlay: "rgba(14, 20, 33, 0.75)",
    spinnerGradient: "linear-gradient(0deg, rgba(14, 20, 33, 0.85) 55%, rgba(14, 20, 33, 0) 100%)",
  },
  link: {
    color: "#35C79B",
    hover: "#4FD9B2",
  },
  scrollbar: {
    track: "#1E2637",
    thumb: "linear-gradient(40deg, #29DEAE -20.66%, #1F8C6E 68.48%)",
    softTrack: "#1E2637",
    softThumb: "#3B4559",
  },
  header: {
    background: "#131A28",
    buttonColor: "#E6EAF4",
    buttonBackground: "rgba(255, 255, 255, 0.08)",
    buttonHoverBackground: "rgba(255, 255, 255, 0.18)",
    userPhotoBackground: "#232C40",
    userPhotoShadow: "rgba(0, 0, 0, 0.45)",
    userPhotoShadowMobile: "rgba(0, 0, 0, 0.35)",
    userInitialColor: "#E6EAF4",
    userNameColor: "#E6EAF4",
    userRoleColor: "rgba(230, 234, 244, 0.65)",
    dropdownButtonColor: "#E6EAF4",
    dropdownButtonIdleColor: "#98A1B5",
    dropdownButtonHoverBackground: "rgba(255, 255, 255, 0.08)",
    dropdownItemColor: "#98A1B5",
    dropdownIconColor: "#E6EAF4",
    burgerColor: "#98A1B5",
    burgerMobileColor: "#E6EAF4",
  },
  sidebar: {
    background: "#161D2C",
    itemColor: "#98A1B5",
    itemHoverBackground: "#232C40",
    activeColor: "#35C79B",
    activeBackground: "#232C40",
    activeBar: "linear-gradient(100deg, #1F8C6E -20.66%, #29DEAE 68.48%)",
    logoColor: "#E6EAF4",
    scrollTrack: "#1E2637",
    scrollThumb: "#3B4559",
  },
  menu: {
    background: "#1E2637",
    color: "#98A1B5",
    hoverBackground: "#232C40",
  },
  table: {
    headColor: "#E6EAF4",
    border: "#2B3446",
    rowHoverColor: "#35C79B",
    rowHoverBackground: "#1E2637",
    actionInfoHover: "#6C9BFF",
    actionDangerHover: "#FF6B7A",
  },
  tabs: {
    titleColor: "#35C79B",
    activeColor: "#35C79B",
    activeBackground: "#232C40",
    hoverBackground: "#232C40",
    indicator: "#29DEAE",
    border: "#2B3446",
  },
  overlay: {
    hover: "rgba(255, 255, 255, 0.06)",
    divider: "rgba(255, 255, 255, 0.12)",
    border: "rgba(255, 255, 255, 0.23)",
    underline: "rgba(255, 255, 255, 0.3)",
    underlineHover: "rgba(255, 255, 255, 0.7)",
    accentSoft: "rgba(255, 255, 255, 0.05)",
    accentMedium: "rgba(255, 255, 255, 0.09)",
    accentStrong: "rgba(255, 255, 255, 0.2)",
  },
  input: {
    color: "#E6EAF4",
    labelColor: "rgba(230, 234, 244, 0.6)",
    labelActiveColor: "#E6EAF4",
    selectLabelColor: "#98A1B5",
    borderColor: "rgba(255, 255, 255, 0.3)",
    borderHoverColor: "#E6EAF4",
    borderFocusColor: "#35C79B",
    focusUnderline: "#5B93EC",
    iconColor: "#98A1B5",
    errorColor: "#FF6B7A",
    autofillBackground: "rgb(30 38 55)",
  },
  button: {
    primary: "linear-gradient(40deg, #3A48A5 30%, #5B93EC 90%)",
    success: "linear-gradient(40deg, #1F8C6E -20%, #29DEAE 70%)",
    danger: "linear-gradient(40deg, #D91C1C 30%, #F1516F 90%)",
    warning: "linear-gradient(40deg, #E06D00 30%, #F0AE31 90%)",
    contrast: "#fff",
    transparentColor: "#35C79B",
  },
  switch: {
    color: "#98A1B5",
    trackColor: "#5A6274",
    checkedColor: "#35C79B",
    checkedHoverBackground: "rgba(53, 199, 155, 0.15)",
  },
  checkbox: {
    color: "#98A1B5",
    checkedColor: "#35C79B",
    hoverBackground: "rgba(255, 255, 255, 0.08)",
    checkedHoverBackground: "rgba(53, 199, 155, 0.15)",
  },
  pagination: {
    itemColor: "#98A1B5",
    selectedColor: "#ffffff",
    selectedBackground: "linear-gradient(40deg, #1F8C6E -20%, #29DEAE 70%)",
  },
  stepper: {
    activeColor: "#35C79B",
    completedColor: "rgba(53, 199, 155, 0.5)",
  },
  dialog: {
    background: "#1E2637",
    headColor: "#E6EAF4",
    closeHoverBackground: "#232C40",
  },
  filter: {
    dropdownBackground: "#1E2637",
    dropdownShadow: "0 5px 5px -3px rgb(0 0 0 / 45%), 0 8px 10px 1px rgb(0 0 0 / 35%), 0 3px 14px 2px rgb(0 0 0 / 30%)",
    blockBackground: "rgba(255, 255, 255, 0.04)",
    titleColor: "#35C79B",
    chipColor: "#E6EAF4",
    chipBorder: "rgba(255, 255, 255, 0.23)",
    chipHoverBackground: "rgba(255, 255, 255, 0.08)",
    clearColor: "#FF6B7A",
    clearHoverBackground: "rgba(255, 107, 122, 0.12)",
    closeColor: "#98A1B5",
    itemsPerPageBackground: "#1E2637",
    submitColor: "rgb(255, 255, 255)",
    submitBackground: "linear-gradient(40deg, rgb(31, 140, 110) -20%, rgb(41, 222, 174) 70%)",
  },
  status: {
    danger: "linear-gradient(40deg, #D91C1C 30%, #F1516F 90%)",
    frozen: "linear-gradient(40deg, #A82121 30%, #E04437 90%)",
    warning: "linear-gradient(40deg, #E06D00 30%, #F0AE31 90%)",
    success: "linear-gradient(40deg, #1F8C6E -20%, #29DEAE 70%)",
    cancelled: "linear-gradient(40deg, #444B59 30%, #8B94A6 90%)",
    default: "linear-gradient(40deg, #3A48A5 30%, #5B93EC 90%)",
    color: "#fff",
  },
  state: {
    danger: "#FF6B7A",
    warning: "#F0AE31",
    success: "#29DEAE",
    info: "#6C9BFF",
    error: "#FF6B7A",
  },
  badge: {
    successColor: "#7EE2A8",
    successBackground: "rgba(41, 222, 174, 0.12)",
    dangerColor: "#FFA8A8",
    dangerBackground: "rgba(255, 107, 122, 0.12)",
    neutralColor: "#98A1B5",
    neutralBackground: "rgba(255, 255, 255, 0.06)",
  },
  iconButton: {
    successColor: "#45CAA7",
    successBorder: "#29DE67",
    successBackground: "rgba(41, 219, 172, 0.12)",
    dangerColor: "#FF6B7A",
    dangerBorder: "#de2929",
    dangerBackground: "rgba(219, 41, 41, 0.15)",
  },
};